import { Button } from '@/app/components/ui/button';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/app/components/ui/alert-dialog';
import type { H3ightboardUnsavedChangesDialogProps } from './use-unsaved-changes-guard';

export function H3ightboardUnsavedChangesDialog({
  open,
  canSave,
  isSaving,
  onStay,
  onDiscardAndLeave,
  onSaveAndLeave,
}: H3ightboardUnsavedChangesDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={(nextOpen) => { if (!nextOpen) onStay(); }}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Leave H3ightboard with unsaved changes?</AlertDialogTitle>
          <AlertDialogDescription>
            You have pending H3ightboard changes that have not been saved. Save them before leaving, discard them, or stay on the board.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="outline" type="button" onClick={onStay}>
            Stay
          </Button>
          <Button variant="destructive" type="button" onClick={onDiscardAndLeave}>
            Discard/Leave
          </Button>
          {canSave && (
            <Button type="button" onClick={onSaveAndLeave} disabled={isSaving}>
              {isSaving ? 'Saving…' : 'Save & Leave'}
            </Button>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
